import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';
import CalendarIcon from '../../../../../assets/icons/calendar.svg';
import {Text} from '../../../../../uikit/Text';
import {View} from '../../../../../uikit/View';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {isMeCoachForEntity} from '../../../../../utils/entity/isMeCoachForEntity';

export const getData = (
  _event: NotificationEvent,
  context: EventContextsMap,
): EventData => {
  const {actor, course, program} = context;
  const courseLabel = getCourseLabel(course);

  const eventData: EventData = {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    icon: CalendarIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:course_stopped.title.common', {
      coachName: actor?.name,
      courseDates: courseLabel ? `(${courseLabel})` : '',
      courseTitle: program?.title,
    }),
  };

  const isCoach = isMeCoachForEntity(course);

  if (isCoach) {
    const isAuthor = currentUserStore.user?._id === actor?._id;

    if (isAuthor) {
      eventData.title = i18n.t('notifications:course_stopped.title.author', {
        courseDates: courseLabel ? `(${courseLabel})` : '',
        courseTitle: program?.title,
      });
    }

    return eventData;
  }

  if (course?.stop_reason) {
    eventData.renderMessage = () => (
      <View style={{display: 'flex', flexDirection: 'column'}}>
        <Text variant="label.la" weight="semibold">
          {`${i18n.t('shared:reason')}:`}
        </Text>
        <Text variant="label.la">{course.stop_reason}</Text>
      </View>
    );
  }

  eventData.buttons = [
    {
      id: 'contact_coach_button',
      label: i18n.t('shared:contact_coach'),
    },
  ];

  return eventData;
};
